// extracted by mini-css-extract-plugin
export var dividerContainer = "_a4-0";
export var line = "_a4-1";